
import { useLocation } from "react-router-dom";
import useChat from "../hooks/useChat";
import ChatList from "../components/Chat/ChatList";
import ChatWindow from "../components/Chat/ChatWindow";
import NotificationBell from "../components/Notifications/NotificationBell";
import EditChatMenu from "../components/Chat/EditChatMenu";

export default function ChatBox() {
  const location = useLocation();

  const {
    conversations, activeConvo, messages,
    text, loading, sending, scrollRef,
    isOnline, isTyping,
    setText, setActiveConvo, handleSend, handleMessageDeleted, sendTyping,
  } = useChat(location.state?.openConvo);

  return (
    <div className="bg-black text-white flex flex-col"
      style={{ height: "calc(100vh - 64px)" }}>

      {/* Header — hide on mobile when a conversation is open */}
      <div className={`items-center justify-between px-4 py-3
        border-b border-white/10
        ${activeConvo ? "hidden md:flex" : "flex"}`}>
        <h1 className="text-lg font-bold text-white">Messages</h1>
        <div className="flex items-center gap-2">
          <NotificationBell />
          <EditChatMenu />
        </div>
      </div>

      {/* Body */}
      <div className="flex-1 flex overflow-hidden">
        <div className={`md:w-1/3 w-full flex flex-col pt-3
          border-r border-white/10
          ${activeConvo ? "hidden md:flex" : "flex"}`}>
          <ChatList
            conversations={conversations}
            activeConvo={activeConvo}
            onSelect={setActiveConvo}
            loading={loading}
          />
        </div>

        <div className={`md:w-2/3 w-full flex flex-col
          ${activeConvo ? "flex" : "hidden md:flex"}`}>
          <ChatWindow
            convo={activeConvo}
            messages={messages}
            text={text}
            sending={sending}
            scrollRef={scrollRef}
            setText={setText}
            onSend={handleSend}
            onBack={() => setActiveConvo(null)}
            onMessageDeleted={handleMessageDeleted}
            isOnline={isOnline}
            isTyping={isTyping}
            sendTyping={sendTyping}
          />
        </div>
      </div>
    </div>
  );
}